import { useEffect, useState } from 'react';
import { asyncGetCasesGeneralInformation } from '../../../../../services/cases-general-information.service';
import { useNavigate, useParams } from 'react-router-dom';
import { CasesGeneralInformation } from '../../../../../shared/types/modules/cases-general-information';
import { ACCOUNTS } from '../../../../../routes/paths';

export const useCasesGeneralInformationDetail = () => {
    const navigate = useNavigate();
    const { idCasesGeneralInformation } = useParams();
    const [loading, setLoading] = useState(false);
    const [casesGeneralInformation, setCasesGeneralInformation] =
        useState<CasesGeneralInformation>();

    useEffect(() => {
        if (Boolean(idCasesGeneralInformation?.trim())) {
            setLoading(true);
            asyncGetCasesGeneralInformation(idCasesGeneralInformation?.trim())
                .then((casesGeneralInformation) => {
                    if (casesGeneralInformation)
                        setCasesGeneralInformation(casesGeneralInformation);
                    else navigate(ACCOUNTS);
                })
                .finally(() => setLoading(false));
        }
    }, [idCasesGeneralInformation]);

    return { loading, casesGeneralInformation };
};
